__turbopack_context__.v({
  "contentWrapper": "Dashboard-module-scss-module__48E1TG__contentWrapper",
  "header": "Dashboard-module-scss-module__48E1TG__header",
  "iframe": "Dashboard-module-scss-module__48E1TG__iframe",
  "iframeContainer": "Dashboard-module-scss-module__48E1TG__iframeContainer",
  "pageWrapper": "Dashboard-module-scss-module__48E1TG__pageWrapper",
  "sectionHeadingTag": "Dashboard-module-scss-module__48E1TG__sectionHeadingTag",
  "sectionTitle": "Dashboard-module-scss-module__48E1TG__sectionTitle",
  "textParagraph": "Dashboard-module-scss-module__48E1TG__textParagraph",
  "textSection": "Dashboard-module-scss-module__48E1TG__textSection",
});
